/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mapping between source and target columns for row presets
 * @export
 * @interface TableColumnMappingDto
 */
export interface TableColumnMappingDto {
    /**
     * Index of source column (0-based)
     * @type {number}
     * @memberof TableColumnMappingDto
     */
    sourceTableColumnIndex?: number;
    /**
     * Index of target column (0-based)
     * @type {number}
     * @memberof TableColumnMappingDto
     */
    thisTableColumnIndex?: number;
}

/**
 * Check if a given object implements the TableColumnMappingDto interface.
 */
export function instanceOfTableColumnMappingDto(value: object): value is TableColumnMappingDto {
    return true;
}

export function TableColumnMappingDtoFromJSON(json: any): TableColumnMappingDto {
    return TableColumnMappingDtoFromJSONTyped(json, false);
}

export function TableColumnMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableColumnMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTableColumnIndex': json['sourceTableColumnIndex'] == null ? undefined : json['sourceTableColumnIndex'],
        'thisTableColumnIndex': json['thisTableColumnIndex'] == null ? undefined : json['thisTableColumnIndex'],
    };
}

export function TableColumnMappingDtoToJSON(json: any): TableColumnMappingDto {
    return TableColumnMappingDtoToJSONTyped(json, false);
}

export function TableColumnMappingDtoToJSONTyped(value?: TableColumnMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTableColumnIndex': value['sourceTableColumnIndex'],
        'thisTableColumnIndex': value['thisTableColumnIndex'],
    };
}

